import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Carousel from "react-elastic-carousel";
import { useAppSelector } from "../../../infra/hooks";
import BirthdayPopper from "../../Lottifiers/BirthdayPopper/BirthdayPopper";
import HappyBirthdayText from "../../Lottifiers/HappyBirthdayText/HappyBirthdayText";

import UserProfileController from "../UserProfileController";
function TodayBirthday() {
  const storeBday = useAppSelector((state) => state.upcomingEventsSlice.events);
  const { t, i18n } = useTranslation();
  const [render, setRender] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (storeBday?.length) {
      storeBday?.map((bday) => {
        if (bday?.notification_type == t("Birthday")) {
          setData(bday);
          setRender(true);
        }
      });
    }
  }, [storeBday]);

  return (
    <div>
      {render && (
        <Carousel
          showArrows={false}
          enableAutoPlay
          enableTilt
          autoPlaySpeed={5000}
          pagination={false}
        >
          {data?.notification_data?.map((bday) => {
            const date = new Date(bday?.date);
            const todayDate = new Date();
            const _date = moment(date).format("DD-MM-YYYY");
            const _todayDate = moment(todayDate).format("DD-MM-YYYY");
            if (_date == _todayDate) {
              return (
                <div key={bday.id}>
                  <div
                    style={{
                      position: "absolute",
                      marginTop: "3em",
                    }}
                  >
                    <BirthdayPopper />
                  </div>
                  <UserProfileController
                    reporter={{ emp_name: bday.name, emp_pic: bday.pic }}
                  />
                  <HappyBirthdayText />
                </div>
              );
            }
          })}
        </Carousel>
      )}

      {/* {data?.notification_data?.map((bday) => {
        const todayDate = new Date();
        const _date = moment(bday?.date).format("MM-DD-YYYY");
        const _todayDate = moment(todayDate).format("MM-DD-YYYY");

        if (_date != _todayDate) {
          console.log("--------Dateesss-----", _date);
          return (
            <div key={bday.id}>
              <UpcomingBirthdayBox name={bday.name} pic={bday.pic} />
            </div>
          );
        }
      })} */}
    </div>
  );
}

export default TodayBirthday;
